import axios from "axios";
import RadioButtons from "./RadioButtons";
import TextInput from "./TextInput";
class Ajax {
    constructor(postType, postPerPage, container, currentPage = 1) {
        this.postPerPage = postPerPage;
        this.currentPage = currentPage;
        this.postType = postType;
        this.container = container;
        this.maxPages = 999;
        this.dropdowns = []; // array of RadioButtons
        this.posts = [];
        this.loadMoreButton = null;
        this.textInput = null;
        this.noResultsElement = null;
    }

    init() {
        this.loadPosts();
    }

    /**
     *
     * @param radioButtonElements array radio button elements that will be used to filter the posts
     * @param taxonomyName string Taxonomy that will be used to filter the posts
     */
    addRadioButtons(radioButtonElements, taxonomyName) {
        if(radioButtonElements) {
            const tmpRadioButtons = new RadioButtons(radioButtonElements, taxonomyName);
            tmpRadioButtons.watchValue((value) => {
                console.log("Ajax.js - Updating value on " + tmpRadioButtons.taxonomyName + " Value: ", value);
                // console.log("Ajax.js - Updated dropdown: ", tmpRadioButtons);

                // manually updating the dropdowns array as the state isn't being saved when all is selected
                // this.dropdowns[taxonomyName] = tmpRadioButtons;
                this.taxonomyChanged(taxonomyName, value);
            })
            this.dropdowns[taxonomyName] = tmpRadioButtons;
        } else {
            // throw error
            throw new Error("Ajax.ts - Error: radio button elements are null");
        }
    }

    addLoadMoreButton(loadMoreButton)
    {
        if(loadMoreButton) {
            this.loadMoreButton = loadMoreButton;

            // when the load more button is clicked, load more posts
            this.loadMoreButton.addEventListener("click", () => {
                this.loadMoreButtonClicked();
            });
        }
    }

    addTextInput(textInput, metaKeys = [null])
    {
        const input = new TextInput(textInput, metaKeys);

        // when the text input is changed, redraw the posts
        input.watchValue((value) => {
            this.textInputChanged(value);
        });

        this.textInput = input;
    }

    addNoResultsElement(noResultsElement)
    {
        this.noResultsElement = noResultsElement;
    }

    /**
     * When the load more button is clicked, load more posts
     */
    loadMoreButtonClicked()
    {
        this.currentPage++;
        this.loadAndAppendPosts();
    }

    /**
     * When one of the taxonomies is updated, redraw the posts
     *
     * @param taxonomyName
     * @param value
     */
    taxonomyChanged(taxonomyName, value) // pinged when one of the taxonomies is updated
    {
        if (this.dropdowns[taxonomyName]) {
            this.redrawPosts();
        }
    }

    /**
     * When the text input is changed, redraw the posts
     */
    textInputChanged()
    {
        this.redrawPosts();
    }

    /**
     * Redraw the posts, removing all posts and reloading them
     */
    redrawPosts()
    {
        this.resetPosts();
        this.loadPosts();
    }

    /**
     * Reset the posts array and the current page
     */
    resetPosts()
    {
        this.posts = [];
        this.currentPage = 1;
        this.container.innerHTML = "";
    }


    /**
     * Set the visibility of the load more button when the max pages is reached
     */
    setLoadMoreButtonVisibility()
    {
        if (this.currentPage >= this.maxPages) {
            this.loadMoreButton.style.display = "none";
        } else {
            this.loadMoreButton.style.display = "block";
        }
    }

    /**
     * Set the max page number from api request headers
     *
     * @param maxPages
     */
    setMaxPages(maxPages)
    {
        if(typeof maxPages !== "number") {
            try {
                maxPages = parseInt(maxPages);
            } catch (e) {
                throw new Error("Ajax.ts - Error: maxPages is not a number")
            }
        }

        this.maxPages = maxPages;

        this.setLoadMoreButtonVisibility()
    }

    /**
     * Load posts and append them to the posts array and the container
     */
    loadAndAppendPosts()
    {
        let route = this.getRoute();
        axios.get(route).then((response) => {
           let posts = response.data;
            console.log("Ajax.ts - Posts: ", posts);
           this.savePosts(posts);
           const postElements = this.convertPostsToElements(posts);
           this.displayPosts(postElements);
           console.log("Ajax.ts - Headers: ", response.headers);
           if (response.headers['x-wp-totalpages']) {
               console.log("Ajax.ts - Max Pages: ", response.headers['x-wp-totalpages']);
               this.setMaxPages(response.headers['x-wp-totalpages']);
           }
        });
    }

    /**
     * Load posts and replace the posts array and the container
     */
    loadPosts() {
        let route = this.getRoute();
        axios.get(route).then((response) => {
            let posts = response.data;
            console.log("Ajax.ts - Posts: ", posts);
            this.savePosts(posts);
            this.displayAllPosts(this.posts);
            console.log("Ajax.ts - Headers: ", response.headers);
            if (response.headers['x-wp-totalpages']) {
                console.log("Ajax.ts - Max Pages: ", response.headers['x-wp-totalpages']);
                this.setMaxPages(response.headers['x-wp-totalpages']);
            }
        });
    }

    /**
     * Convert post objects to post elements so they can be rendered
     *
     * @param postObjects
     * @returns {*[]}
     */
    convertPostsToElements(postObjects)
    {
        let postElements = [];

        for (let post of postObjects) {
            const postElement = this.createPostElement(post);
            if (postElement) {
                postElements.push(postElement);
            }
        }

        return postElements;
    }

    /**
     * Save posts to the posts array
     *
     * @param posts
     */
    savePosts(posts)
    {
        const postElements = this.convertPostsToElements(posts);

        for (let post of postElements) {
            this.posts.push(post);
        }
    }

    /**
     * Render a post to the container
     *
     * @param post
     */
    renderPost(post)
    {
        // if post is a HTMLElement
        if (post instanceof HTMLElement) {
            this.container.appendChild(post);
        }
    }

    /**
     * Display specific posts to the container
     *
     * @param posts
     */
    displayPosts(posts)
    {
        for (let post of posts) {
            this.renderPost(post);
        }
    }

    /**
     * Toggle the no results element based on the number of posts
     */
    toggleNoResultsElement()
    {
        if (this.noResultsElement) {
            if (this.posts.length !== 0) {
                this.noResultsElement.style.display = "none";
            } else {
                this.noResultsElement.style.display = "block";
            }
        }
    }

    /**
     * Display all posts to the container
     */
    displayAllPosts()
    {
        this.container.innerHTML = "";

        this.toggleNoResultsElement();

        // if there are posts
        if (this.posts.length > 0) {
            for (let post of this.posts) {
                this.renderPost(post);
            }
        }
    }

    /**
     * Create a post element from a post object
     *
     * @param post
     * @returns {HTMLElement|null}
     */
    createPostElement(post)
    {
        // if the post is an object
        if (typeof post === "object") {
            let tempTemplate = document.createElement("article");
            tempTemplate.classList.add("article");
            const html = typeof post.card !== "undefined" ? post.card.trim() : "";
            tempTemplate.innerHTML = html;
            return tempTemplate;
        }

        return null;
    }

    /**
     * Get the base route for the ajax request
     *
     * @returns {string}
     */
    getBaseRoute()
    {
        return "/wp-json/wp/v2/" + this.postType;
    }

    /**
     * Get the route for the ajax request with all the filters
     *
     * @returns {string}
     */
    getRoute()
    {
        let tmpRoute = this.getBaseRoute() + "?per_page=" + this.postPerPage + "&page=" + this.currentPage + "&orderby=date&order=desc";

        console.log("Ajax.ts - Dropdowns: ", this.dropdowns);
        for (const [key, value] of Object.entries(this.dropdowns)) {
            if (value.getValue() !== null && value.getValue() !== "") {
                tmpRoute += "&" + value.taxonomyName + "=" + value.getValue();
            }
        }

        // if the text input has a value, add either the search or the meta key to the route if meta keys are set
        // if you need both search and meta keys, you will need to add them manually to the rest api
        if (this.textInput && this.textInput.getValue() !== "") {
            // if the text input has meta keys, add them to the route
            // Ensure that the meta key is set as a new custom peram as per CLASS.Post.php
            if (this.textInput.metaKeys.length > 0) {
                this.textInput.metaKeys.forEach((metaKey) => {
                    tmpRoute += "&" + metaKey + "=" + this.textInput.getValue();
                });
            } else {
                tmpRoute += "&search=" + this.textInput.getValue();
            }
        }

        console.log("Ajax.ts - Route: ", tmpRoute);
        return tmpRoute;
    }

    getPosts()
    {
        return this.posts;
    }
}

export default Ajax;
